import { ZoomRegion } from '@/store/editor-store'
import { MouseEvent as TrackedMouseEvent } from '@/store/recording-store'

export const DEMO_VIDEO_PATH = '/demo-video.webm'
export const DEMO_VIDEO_DURATION = 30

export const DEMO_MOUSE_DATA: TrackedMouseEvent[] = [
    { t: 0, x: 960, y: 540, type: 'move' },
    { t: 500, x: 400, y: 300, type: 'move' },
    { t: 1000, x: 400, y: 300, type: 'dwell' },
    { t: 2500, x: 1500, y: 800, type: 'move' },
    { t: 3000, x: 1500, y: 800, type: 'dwell' },
    { t: 5000, x: 960, y: 540, type: 'move' },
    { t: 5500, x: 960, y: 540, type: 'dwell' },
]

export const DEMO_ZOOM_REGIONS: ZoomRegion[] = [
    {
        id: 'demo-zoom-1',
        startTime: 0.74,
        endTime: 2.6,
        scale: 1.4,
        x: 0,
        y: 0,
        ease: 'easeInOut',
        mode: 'focus'
    },
    {
        id: 'demo-zoom-2',
        startTime: 3.54,
        endTime: 5.24,
        scale: 1.5,
        x: 1,
        y: -20,
        ease: 'easeInOut',
        mode: 'focus'
    },
    {
        id: 'demo-zoom-3',
        startTime: 7.2,
        endTime: 10.26,
        scale: 1.5,
        x: 1,
        y: -14,
        ease: 'easeInOut',
        mode: 'focus'
    },
    {
        id: 'demo-zoom-4',
        startTime: 11.36,
        endTime: 22.5,
        scale: 1.5,
        x: 0,
        y: 0,
        ease: 'easeInOut',
        mode: 'focus'
    },
    {
        id: 'demo-zoom-5',
        startTime: 26.5,
        endTime: 28.44,
        scale: 1.5,
        x: 13,
        y: 14,
        ease: 'easeInOut',
        mode: 'focus'
    }
]
